<script lang="ts">
    import BookFilter from "./BookFilter.svelte";
    import Creatures from "./Creatures.svelte";
    import DescriptorFilters from "./DescriptorFilters.svelte";
    import EncounterBuilder from "./EncounterBuilder.svelte";
    import Encounters from "./Encounters.svelte";
    import Filter from "./Filter.svelte";
    import Tabs from "./Tabs.svelte";
    import Header from "./Header.svelte";
    import Footer from "./Footer.svelte";
    import Sorting from "./Sorting.svelte";
    import { UI } from "./ui.store";
    import { fly } from "svelte/transition";
</script>

<Header />
<main>
    <div class="content">
        <h1>Shadow of the Demon Lord Encounter Generator</h1>
        <div class="control-panel">
            <div class="row">
                <div class="col">
                    <BookFilter />
                </div>
                <div class="col">
                    <DescriptorFilters />
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="row">
                        <Filter />
                        <Sorting />
                    </div>
                </div>
                <div class="col">
                    <EncounterBuilder />
                </div>
            </div>
        </div>
        <hr />
        <div class="tabs">
            <Tabs />
        </div>
        <div class="view">
            {#if $UI.showBestiary}
                <!-- <div
                    transition:fly={{ duration: 500, y: 0, x: -1000 }}
                    on:introstart={(e) =>
                        (e.target.style.position = "absolute")}
                    on:introend={(e) => (e.target.style.position = "")}
                > -->
                <Creatures />
            {:else}
                <!-- <div
                    transition:fly={{ duration: 500, y: 0, x: 1000 }}
                    on:introstart={(e) =>
                        (e.target.style.position = "absolute")}
                    on:introend={(e) => (e.target.style.position = "")}
                > -->
                <div>
                    <Encounters />
                </div>
            {/if}
        </div>
    </div>
</main>

<Footer />

<style>
    main {
        display: flex;
        flex-direction: column;
        align-items: center;
        background-image: url("./../static/images/SotDL_Core_page_BG_light_40_percent.jpg");
        background-repeat: no-repeat;
        background-size: cover;
        background-color: #cccccc;
        width: 100%;
        height: calc(100% - 48px - 64px);
        overflow: hidden;
    }
    h1 {
        font-family: "FirstV2";
        margin-top: 0px;
        text-align: center;
    }

    .content {
        padding: 16px;
        overflow-y: auto;
        box-sizing: border-box;
        width: 100%;
    }
    .tabs {
        width: 100%;
        display: flex;
        flex-direction: row;
        text-align: center;
    }

    /* Small devices (landscape phones, 576px and up) */
    @media (min-width: 576px) {
    }

    /* Medium devices (tablets, 768px and up) */
    @media (min-width: 768px) {
        .row {
            display: flex;
            flex-direction: row;
            width: 100%;
        }
        .col {
            display: flex;
            flex-direction: column;
            height: 100%;
            flex-basis: 0;
            flex-grow: 1;
        }

        .control-panel {
            margin: 0 32px;
        }
    }

    /* Large devices (desktops, 992px and up) */
    @media (min-width: 992px) {
    }

    /* Extra large devices (large desktops, 1200px and up) */
    @media (min-width: 1200px) {
    }

    hr {
        border: 1px solid ccc;
        opacity: 100%;
        width: 98%;
    }
</style>
